import type { InputHTMLAttributes } from 'react';

/**
 * Keep Safari iCloud Keychain (Hide My Email / saved passwords) and other
 * password managers from treating a filter field as a login or email input.
 * Pair with `readOnly` until first focus — Safari skips Keychain on readonly fields.
 */
export const FILTER_INPUT_AUTOFILL_ATTRS = {
  autoComplete: 'off',
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
  inputMode: 'search',
  'data-1p-ignore': 'true',
  'data-lpignore': 'true',
  'data-form-type': 'other',
} as const satisfies Pick<
  InputHTMLAttributes<HTMLInputElement>,
  'autoComplete' | 'autoCorrect' | 'autoCapitalize' | 'spellCheck' | 'inputMode'
> & {
  'data-1p-ignore': string;
  'data-lpignore': string;
  'data-form-type': string;
};

/** Unlock immediately so the first keystroke is not lost before React re-renders. */
export function unlockFilterInputAfterFocus(el: HTMLInputElement): void {
  if (el.readOnly) el.removeAttribute('readonly');
}
